import type { UnknownQueryParam, PageRouteDefinition, QueryParamValues, QueryParamValuesSetter } from "@octopusdeploy/portal-routes";
import type { ReactElement } from "react";
import type { PermissionCheckProps } from "~/components/PermissionCheck/PermissionCheck";
import type { Loader } from "~/routing/pageRegistrations/Loader";
import type { LoadingContentRender, PageRegistration } from "~/routing/pageRegistrations/PageRegistration";
import type { StandardLoaderContext } from "~/routing/pageRegistrations/StandardLoaderContext";
import type { StandardPageContext } from "./StandardPageContext";
import type { PageOwner } from "./pageOwner";
export function createLevel1TenantPageRegistration<RouteParams, QueryParams extends UnknownQueryParam[], LoaderData>(route: PageRouteDefinition<RouteParams, QueryParams>, config: {
    render: (parameters: {
        context: StandardPageContext;
        loaderData: LoaderData;
        routeParams: RouteParams;
        queryParams: QueryParamValues<QueryParams>;
        setQueryParams: QueryParamValuesSetter<QueryParamValues<QueryParams>>;
    }) => ReactElement;
    pageId: string;
    pageName: string;
    pageArea: string;
    owner: PageOwner;
    loader?: Loader<LoaderData, StandardLoaderContext, RouteParams, QueryParams>;
    loadingTitle?: string;
    loadingContent?: LoadingContentRender;
    helpContent?: () => ReactElement;
    helpTopics?: () => ReactElement;
    requiredPermission?: PermissionCheckProps;
}): PageRegistration<RouteParams, QueryParams, LoaderData, StandardLoaderContext, StandardPageContext> {
    return {
        route,
        render: config.render,
        pageId: config.pageId,
        pageName: config.pageName,
        pageArea: config.pageArea,
        owner: config.owner,
        verticalNavigationPageArea: "Projects",
        searchKeywords: [],
        loader: config.loader,
        loadingTitle: config.loadingTitle,
        loadingContent: config.loadingContent,
        helpContent: config.helpContent,
        helpTopics: config.helpTopics,
        level: 1,
        isFullWidth: true,
        requiredPermission: config.requiredPermission,
    };
}
export function createLevel2TenantPageRegistration<RouteParams, QueryParams extends UnknownQueryParam[], LoaderData>(route: PageRouteDefinition<RouteParams, QueryParams>, config: {
    render: (parameters: {
        context: StandardPageContext;
        loaderData: LoaderData;
        routeParams: RouteParams;
        queryParams: QueryParamValues<QueryParams>;
        setQueryParams: QueryParamValuesSetter<QueryParamValues<QueryParams>>;
    }) => ReactElement;
    pageId: string;
    pageName: string;
    pageArea: string;
    owner: PageOwner;
    loader?: Loader<LoaderData, StandardLoaderContext, RouteParams, QueryParams>;
    loadingTitle?: string;
    loadingContent?: LoadingContentRender;
    helpContent?: () => ReactElement;
    helpTopics?: () => ReactElement;
    isFullWidth?: boolean;
}): PageRegistration<RouteParams, QueryParams, LoaderData, StandardLoaderContext, StandardPageContext> {
    return {
        route,
        render: config.render,
        pageId: config.pageId,
        pageName: config.pageName,
        pageArea: config.pageArea,
        owner: config.owner,
        verticalNavigationPageArea: "Projects",
        searchKeywords: [],
        loader: config.loader,
        loadingTitle: config.loadingTitle,
        loadingContent: config.loadingContent,
        helpContent: config.helpContent,
        helpTopics: config.helpTopics,
        level: 2,
        isFullWidth: config.isFullWidth ?? false,
    };
}
